import { Listbox } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { SpinnerIcon } from '../../Spinner';
import { SelectOption } from './types';

type SelectInputProps = {
  value: SelectOption | undefined;
  placeholder?: string;
  placeholderImage?: ReactNode
  isLoading?: boolean;
  className?: string;
  error?: string;
};

export const SelectInput: FC<SelectInputProps> = ({ value, placeholder, placeholderImage, isLoading, error, className }) => {
  const { t } = useTranslation();

  return (
    <Listbox.Button
      className={({ open, disabled }) =>
        twMerge(
          'w-full border border-transparent ring-1 drop-shadow-sm ring-secondary-border rounded-lg ps-3.5 pr-10 py-2.5 text-left',
          'focus-within:outline-none focus-within:ring-2 focus-within:ring-brand-500',
          open ? 'ring-2 ring-brand-500' : '',
          error ? 'ring-red-500 hover:ring-red-500 focus-within:ring-red-500' : '',
          disabled ? 'bg-disabled-subtle text-quaternary-500 cursor-not-allowed' : '',
          'motion-safe:transition-colors motion-safe:duration-300 motion-reduce:transition-none',
          className
        )
      }
    >
      <div className='flex items-center gap-3 pe-6'>
        {value ? (
          <>
            {value.image && <span>{value.image}</span>}
            <p className='truncate text-primary-900'>{value.label}</p>
          </>
        ) : (
          <>
            {placeholderImage && <span>{placeholderImage}</span>}
            <p className='text-other-textPlaceholder'>{placeholder || t('COMMON:selectPlaceholder')}</p>            
          </>

        )}
      </div>

      <span className='absolute inset-y-0 right-0 flex items-center pe-3.5'>
        {isLoading ? <SpinnerIcon className='size-4' /> : <ChevronDownIcon className='size-5 text-quaternary-400' aria-hidden='true' />}
      </span>
    </Listbox.Button>
  );
};
